import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";

const RecommendationsSubNav = ({ active }) => {
    const navigate = useNavigate();

    return (
        <div className="flex gap-2">
            <Button
                label="By Provider"
                icon="pi pi-users"
                className={active === "providers" ? "p-button-sm" : "p-button-sm p-button-outlined"}
                onClick={() => navigate("/account/admin/provider-recommendations")}
            />
            <Button
                label="By Recommendation"
                icon="pi pi-list"
                className={active === "summary" ? "p-button-sm" : "p-button-sm p-button-outlined"}
                onClick={() => navigate("/account/admin/recommendation-summary")}
            />
        </div>
    );
};

export default RecommendationsSubNav;
